/**
 * DisableRightClickWrapper - A component that prevents right-clicking on its children
 */
import React, { useEffect } from 'react';

const DisableRightClick = ({ children, disableRightClick = true }) => {
  useEffect(() => {
    // Only apply if disableRightClick is true
    if (!disableRightClick) return;
    
    // Function to handle right click
    const handleRightClick = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listener
    document.addEventListener('contextmenu', handleRightClick);

    // Clean up event listener when component unmounts
    return () => {
      document.removeEventListener('contextmenu', handleRightClick);
    };
  }, [disableRightClick]);

  return <div className='h-screen scrollableNoScrollbarForSMD'>{children}</div>;
};

export default DisableRightClick;